import React, { useContext, useEffect, useState } from "react";
import TopToolbar from "./Toolbar/TopToolbar";
import DeepTek from "../../../assets/DeepTek.png";
import OutlineButton from "./Tools/ToolComponents/OutlineButton";
import studyviewerContext from "../../../context/studyviewer/StudyviewerContext";
import HeatMapButton from "./Tools/ToolComponents/HeatMapButton";
import ShowOriginal from "./Tools/ToolComponents/ShowOriginal";
import { TooltipHost } from "@fluentui/react/lib/Tooltip";
import { useId } from "@fluentui/react-hooks";
import {
  ADVANCE_VIEWER_MODALITIES,
  ADVANCE_VIEWER_URL,
  BASIC_VIEWER_URL,
  COMPARE_TOOL_OBJECT,
  MPR_TOOL_OBJECT,
  REACT_ADVANCE_VIEWER_URL,
  REPORTDONESTATUS,
  SHOW_NOT_ORIGNAL_MODALITY_LIST,
  SHOW_OUTLINE_HEATMAP_FOR_MODALITY_LIST,
  USERTYPES,
  ECG,
  showPathologyForModalities,
} from "../../../constants/Constants";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import CustomSpinner from "../../../components/CustomSpinner";
import { useTranslation } from "react-i18next";
import {
  downloadStudyZip,
  _base64ToArrayBuffer,
} from "../../../service/StudyViewerService";
import ThumbnailContext from "../../../context/studyviewer/ThumbnailContext";
import ViewportContext from "../../../context/studyviewer/ViewportContext";
import ReportIcon from "../../../components/SVGComponents/ReportIcon";
import AddPathologyIcon from "../../../components/SVGComponents/AddPathologyIcon";
import AnnotationBox from "../../Annotations/components/AnnotationBox/AnnotationBox";
import "../styles/styles.css";
import ChevronDownIcon from "../../../components/SVGComponents/ChevronDownIcon";
import ChatIcon from "../../../components/SVGComponents/ChatIcon";
import AttachmentIcon from "../../../components/SVGComponents/AttachmentIcon";
import AttachmentBox from "./AttachmentBox/AttachmentBox";
import ClinicalNotesIcon from "../../../components/SVGComponents/ClinicalNotesIcon";
import LockStudyTopBarIcon from "../../../components/SVGComponents/LockStudyTopBarIcon";
import studyReportContext from "../../../context/studyreport/StudyReportContext";
import DownloadButton from "./Tools/ToolComponents/DownloadButton";
import Augmento from "../../../components/SVGComponents/Logo/Augmento";
import DeeptekLogo from "../../../components/SVGComponents/Logo/DeeptekLogo";
import ShareStudyLink from "../../StudyList/components/Actions/ShareStudyLink";
import ShareIcon from "../../../components/SVGComponents/ShareIcon";
import ShareStudyContext from "../../../context/sharestudy/ShareStudyContext";
import { isMobile } from "react-device-detect";
import Back from "../../../components/SVGComponents/Tools/Back";
import themeContext from "../../../context/theme/ThemeContext";
import Tool from "./Tools/ToolComponents/Tool";
import userContext from "../../../context/users/UserContext";
import MPRToolComponent from "./Tools/ToolComponents/MPRToolComponent";
import BasicViewerSwitch from "../../../components/SVGComponents/BasicViewerSwitch";
import { logAmplitudeEventWithUsernameAndRole } from "../../../helpers/Amplitude";
import AdvanceViewerSwitch from "../../../components/SVGComponents/Tools/AdvanceViewerSwitch";
import AdvKeyImagesModal from "./AdvKeyImagesModal/AdvKeyImagesModal";
import KeyImage from "../../../components/SVGComponents/Tools/KeyImage";
import CustomToolTipHost from "../../../components/CustomToolTipHost/CustomToolTipHost";
import LockStudy from "./LockStudy/LockStudy";
import { KeyboardClassicIcon } from "@fluentui/react-icons-mdl2";
import TypistAccessCode from "../../StudyList/components/Typist/TypistAccessCode";
import MicToolComponent from "./Tools/ToolComponents/MicToolComponent";
import MobileViewerContext from "../../../context/studyviewer/MobileViewerContext";

const AdvTopBar = (props) => {
  const{slideReportOpen,setSlideReportOpen} = useContext(MobileViewerContext);
  const {
    studyData,
    messageCount,
    patientStudyData,
    studyModality,
    studyHistoryData,
    studyClinicalNotesData,
    assignmentData,
    firmViewerId,
    setSwitchingToBasic,
    studyParentAssignmentData,
    showAttachment, setShowAttachment,
    showClinicalNotes, setShowClinicalNotes,
    isTypistWorkflowEnabled,
    typistShowHistory,
    showChats,
    isPriorsStudy
  } = useContext(studyviewerContext);
  const { theme,themeName } = useContext(themeContext);
  const { disableAddPathology, setDisableAddPathology, isMPRActive } =
    useContext(ViewportContext);
  const {
    showLockWarning,
    lockStudy,
    showLockButton,
    alreadyLocked,
    reportMenu,
    setShowReturnStudyModal,
    reportDoneStatusState,
    showCommunicationModal,
    studyParentId,
    setShowCommunicationModal,
    lockStudySupervisor,
  } = useContext(studyReportContext);

  // const { activeModality } = useContext(ThumbnailContext);

  const { roles, authenticated, loadByUsername, username, userId, privilegedFirmDoctor } =
    useContext(userContext);

  const { showShareStudyLinkModal, setShowShareStudyLinkModal } =
    useContext(ShareStudyContext);
  const [showManageAdvKeyImagesModal, setShowManageAdvKeyImagesModal] =
    useState(false);
  const [changeLockIcon, setChangeLockIcon] = useState(false);
  const [showTypistModal, setShowTypistModal] = useState(false);
  const [t] = useTranslation();

  const toolBarFlex = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
  };

  const handleKeyImageClick = () => {
    setShowManageAdvKeyImagesModal(true);
  };

  const getStudyHistoryData = () => {
    return studyHistoryData;
  };

  const getStudyClinicalData = () => {
    return studyClinicalNotesData;
  };

  if (isMobile) {
    return (
      <>
        <div
          className="topbar-container w100"
          style={{
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div className="topbar-buttons">
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                padding: "0px 5px",
              }}
              onClick={() => window.close()}
            >
              <Back />
            </div>
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                paddingLeft: "10px",
              }}
            >
              {/* <Augmento /> */}
              <DeeptekLogo />
            </div>
          </div>
          <div
            className="topbar-buttons cursor-pointer"
            style={{
              paddingRight: "10px",
            }}
          >
            {/* <TopToolbar
              openSeries={props.openSeries}
              seriesMenu={props.seriesMenu}
            /> */}
            {roles[0] !== USERTYPES.FIRMDOCTOR &&
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
              }}
              onClick={() => {
                // Toggle logic: open report, close others
                setSlideReportOpen((prev) => !prev);
                setShowAttachment(false);
                setShowClinicalNotes(false);
                setShowCommunicationModal(false);
              }}
            >
              <ReportIcon active={slideReportOpen} color={theme.palette.inactiveTool} />
              <span
                style={{
                  fontSize: "8px",
                  lineHeight: "100%",
                  fontWeight: "400",
                  color: "var(--mobile-color-txt)",
                  margin: "4px",
                }}
              >
                Report
              </span>
            </div>
            }
            <div
              className="topbar-buttons cursor-pointer"
              style={{
                position: "relative",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                paddingRight: "5px",
              }}
              onClick={() => setShowCommunicationModal(true)}
            >
              <ChatIcon 
                color={theme.palette.inactiveTool}
                active={showCommunicationModal} />
              {messageCount > 0 && <span className="message-count-tag"></span>}
              {isMobile && (
                <span
                  style={{
                    fontSize: "8px",
                    lineHeight: "100%",
                    fontWeight: "400",
                    // color: "#FFFFFF",
                    color: "var(--mobile-color-txt)",
                    marginTop: "5px",
                  }}
                >
                  Chat
                </span>
              )}
            </div>
            {!(studyModality.toUpperCase() === ECG.toUpperCase()) && (
              <div
                className="topbar-buttons cursor-pointer"
                style={{
                  position: "relative",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "65px",
                }}
                onClick={() => {
                  if (window.location.href.includes("nonXrayAdvanceViewer")) {
                    window.open(
                      "/new/study/load/" + studyParentId + "?firmId=" + firmViewerId,
                      "_self"
                    );
                  } else {
                    window.open(
                      REACT_ADVANCE_VIEWER_URL +
                        studyParentId +
                        "?firmId=" +
                        firmViewerId,
                      "_self"
                    );
                  }
                }}
              >
                <AdvanceViewerSwitch color={theme.palette.inactiveTool} />
                {isMobile && (
                  <span
                    style={{
                      fontSize: "8px",
                      lineHeight: "100%",
                      fontWeight: "400",
                      // color: "#FFFFFF",
                      color: "var(--mobile-color-txt)",
                      marginTop: "3px",
                    }}
                  >
                    Basic Viewer
                  </span>
                )}
              </div>
            )}
          </div>
        </div>
      </>
    );
  } else {
    return (
      <>
        <div className="topbar-container w100">
          <div className="topbar-augmento-logo ">
            {/* <Augmento /> */}
            <DeeptekLogo />
          </div>
          <div className="topbar-toolbar-container">
            <div className="topbar-toolbar-left-container">
              {/* <TopToolbar
                openSeries={props.openSeries}
                seriesMenu={props.seriesMenu}
              /> */}
            </div>
            <div className="topbar-toolbar-middle-container">
              {/* {props.priors && <Tool tool={COMPARE_TOOL_OBJECT} />}
              {!MPR_TOOL_OBJECT.NotFor.includes(activeModality) && (
                // <Tool tool={MPR_TOOL_OBJECT} />
                <MPRToolComponent />
              )} */}
            </div>

            <div className="topbar-toolbar-right-container h100">
              {
                <>
                  {/* {process.env.REACT_APP_HYBRID_MODE == "true" && <span
                    style={{
                      display: "flex",
                      margin: "0px 5px",
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onClick={() => {
                      logAmplitudeEventWithUsernameAndRole(
                        "EVENT_BASIC_SWITCH_TO_BASIC_VIEWER",
                        {},
                        username
                      );
                      setSwitchingToBasic((prev)=> !prev);
                      window.open(
                        BASIC_VIEWER_URL + studyParentId + "?firmId=" + firmId,
                        "_self"
                      );
                    }}
                  >
                    <div className="highlight-tool">
                      <CustomToolTipHost
                        content={"Switch to Basic Viewer"}
                        id="basic-viewer"
                      >
                        <span className="topbar-toolbar-right-icons">
                          <BasicViewerSwitch />
                        </span>
                      </CustomToolTipHost>
                    </div>
                  </span>} */}

                  {!(studyModality.toUpperCase() === ECG.toUpperCase()) && (
                    <span
                      style={{
                        display: "flex",
                        margin: "0px 5px",
                        cursor: "pointer",
                        position: "relative",
                      }}
                      onClick={() => {
                        if (
                          window.location.href.includes("nonXrayAdvanceViewer")
                        ) {
                          if(isPriorsStudy){
                            window.open(
                              "/new/study/priors/load/" +
                                studyParentId +
                                "?firmId=" +
                                firmViewerId,
                              "_self"
                            );
                          }else{
                            window.open(
                              "/new/study/load/" +
                                studyParentId +
                                "?firmId=" +
                                firmViewerId,
                              "_self"
                            );
                          }
                        } else {
                          window.open(
                            REACT_ADVANCE_VIEWER_URL +
                              studyParentId +
                              "?firmId=" +
                              firmViewerId,
                            "_self"
                          );
                        }
                      }}
                    >
                      <div className="highlight-tool">
                        <CustomToolTipHost
                          content={
                            window.location.href.includes(
                              "nonXrayAdvanceViewer"
                            )
                              ? "Switch to Basic Viewer"
                              : "Switch to Advance Viewer"
                          }
                          id="basic-viewer"
                        >
                          <span className="topbar-toolbar-right-icons">
                            <AdvanceViewerSwitch  color={theme.palette.inactiveTool}  />
                          </span>
                        </CustomToolTipHost>
                      </div>
                    </span>
                  )}
                </>
              }
                {(roles[0] == USERTYPES.RADIOLOGIST && (reportDoneStatusState == REPORTDONESTATUS.SAVED ||reportDoneStatusState == REPORTDONESTATUS.UNREPORTED ) &&  (isTypistWorkflowEnabled==1 || isTypistWorkflowEnabled==2)) &&
                <div
                  className="topbar-toolbar-share-study-modal-container cursor-pointer"
                  onClick={() => setShowTypistModal(true)}
                >
                  <CustomToolTipHost
                    id={"Assign Typist"}
                    content={ t("heading.typist")}
                  >
                    <div className="highlight-tool">
                      <KeyboardClassicIcon color={theme.palette.inactiveTool} />
                    </div>
                  </CustomToolTipHost>
                </div>
              }
              <div className="highlight-tool cursor-pointer">
                <MicToolComponent />
              </div>
              <LockStudy
                changeLockIcon={changeLockIcon}
                setChangeLockIcon={setChangeLockIcon}
              />
              {/* here key images pop */}
              <CustomToolTipHost
                content={t("key-image.manage-key-image")}
                id="key-images"
              >
                <span
                  className="topbar-toolbar-key-image"
                  style={{
                    cursor: "pointer",
                  }}
                >
                  <div style={toolBarFlex} onClick={handleKeyImageClick}>
                    <KeyImage color={theme.palette.activeTool} />
                  </div>
                </span>
              </CustomToolTipHost>
              {showManageAdvKeyImagesModal && (
                <AdvKeyImagesModal
                  showManageAdvKeyImagesModal={showManageAdvKeyImagesModal}
                  setShowManageAdvKeyImagesModal={
                    setShowManageAdvKeyImagesModal
                  }
                  studyId={studyParentId}
                />
              )}
              {((roles[0] == USERTYPES.TYPIST && typistShowHistory) || roles[0] != USERTYPES.TYPIST)&&<>
              <span
                className="topbar-toolbar-history"
                style={{
                  cursor:
                    studyHistoryData.length > 0 ? "pointer" : "not-allowed",
                }}
                onClick={() => {
                  if (studyHistoryData.length > 0) setShowAttachment(true);
                }}
              >
                <span
                  style={{
                    display: "flex",
                    marginLeft: "5px",
                    merginRight: "5px",
                    cursor:
                      studyHistoryData.length > 0 ? "pointer" : "not-allowed",
                    position: "relative",
                  }}
                  onClick={() => {
                    if (studyHistoryData.length > 0) setShowAttachment(true);
                  }}
                >
                  <div className="highlight-tool">
                    <CustomToolTipHost
                      content={
                        studyHistoryData.length > 0
                          ? t("heading.attachment")
                          : t("search-message.no-attachment")
                      }
                      id="Attachment"
                    >
                      <span className="topbar-toolbar-right-icons">
                        <AttachmentIcon color={theme.palette.inactiveTool} active={showAttachment} />
                        {studyHistoryData.length > 0 && !showAttachment && (
                          <span className="default-show-dot"></span>
                        )}
                      </span>
                    </CustomToolTipHost>
                  </div>
                  <div>
                    <AttachmentBox
                      boxName="history"
                      show={showAttachment}
                      onClickOutside={() => {
                        setShowAttachment(false);
                      }}
                      setShowAttachment={setShowAttachment}
                      setShowPathologyOptions={props.setShowPathologyOptions}
                      setShowInfo1={showAttachment}
                      studyHistoryData={getStudyHistoryData()}
                    />
                  </div>
                </span>
              </span>

              <span
                className="topbar-toolbar-history"
                style={{
                  cursor:
                    studyClinicalNotesData.length > 0
                      ? "pointer"
                      : "not-allowed",
                  margin: "0px 5px",
                }}
                onClick={() => {
                  studyClinicalNotesData.length > 0 &&
                    setShowClinicalNotes(true);
                }}
              >
                <div className="highlight-tool">
                  <CustomToolTipHost
                    content={
                      studyClinicalNotesData.length > 0
                        ? t("heading.clinical-notes")
                        : t("search-message.no-clinical-notes")
                    }
                    id="ClinicalNotes"
                  >
                    <span className="topbar-toolbar-right-icons">
                      <ClinicalNotesIcon color={theme.palette.inactiveTool}  active={showClinicalNotes} />
                      {studyClinicalNotesData.length > 0 &&
                        !showClinicalNotes && (
                          <span className="default-show-dot"></span>
                        )}
                    </span>
                  </CustomToolTipHost>
                </div>
                <div>
                  <AttachmentBox
                    boxName="notes"
                    show={showClinicalNotes}
                    onClickOutside={() => {
                      setShowClinicalNotes(false);
                    }}
                    setShowClinicalNotes={setShowClinicalNotes}
                    setShowPathologyOptions={props.setShowPathologyOptions}
                    setShowInfo1={showClinicalNotes}
                    studyClinicalNotesData={getStudyClinicalData()}
                  />
                </div>
              </span>
              </>}
              <div className="separator-topbar-items"></div>
              <div className="topbar-buttons">
                {((roles[0] == USERTYPES.TYPIST && showChats) || roles[0] != USERTYPES.TYPIST)&&<div
                  className="topbar-toolbar-communication cursor-pointer"
                  onClick={() => setShowCommunicationModal(true)}
                >
                  <div className="highlight-tool">
                  <span className="topbar-toolbar-right-icons">
                    <ChatIcon 
                      //color={true} 
                      color={theme.palette.inactiveTool}
                      active={showCommunicationModal} 
                      />
                    {messageCount > 0 && (
                      <span className="message-count-tag"></span>
                    )}
                  </span>
                  </div>
                </div>}
                {/* <div className="topbar-toolbar-communication-modal-container cursor-pointer">
                  <div className="highlight-tool">
                    <DownloadButton />
                  </div>
                </div> */}
                {showTypistModal &&
                  <TypistAccessCode  setShowTypistModal = {setShowTypistModal} studyId = {studyParentId} isTypistWorkflowEnabled={isTypistWorkflowEnabled}/>
                }
                {showShareStudyLinkModal && (
                  <ShareStudyLink
                    studyId={studyParentId}
                    firmId={assignmentData.firmId}
                    clientId={assignmentData.clientId}
                  />
                )}

                <div
                  className="topbar-toolbar-share-study-modal-container cursor-pointer"
                  onClick={() => setShowShareStudyLinkModal(true)}
                >
                  <div className="highlight-tool">
                    <ShareIcon color={theme.palette.inactiveTool} />
                  </div>
                </div>
              </div>
              {roles.length > 0 && (!roles[0].includes(USERTYPES.FIRMDOCTOR)  || privilegedFirmDoctor) && (
                <CustomToolTipHost content="Report" id="View Report">
                  <button
                    onClick={props.openReport}
                    className="view-report-primay-button"
                    style={{
                      background: reportMenu
                        ? "rgb(0, 120, 212)"
                        : "transparent",
                      border: reportMenu
                        ? "1px solid transparent"
                        : "1px solid #C3C4CD",
                    }}
                  >
                    <span style={{ display: "flex" }}>
                      <ReportIcon active={reportMenu}  color={theme.palette.inactiveTool} />
                    </span>
                    <span className="view-report-button-text" style={{color:reportMenu || themeName !== "light"?"#FFF":"#000"}}>
                      {t("report-version.report")}
                    </span>
                  </button>
                </CustomToolTipHost>
              )}
            </div>
          </div>
        </div>
      </>
    );
  }
};

export default AdvTopBar;
